import { OAuth2Service } from "_services";
import i18n from "i18n";
import React from "react";
import { connect } from "react-redux";
import { Form, ButtonToolbar, Button, Schema } from "rsuite";
import { Translation } from "react-i18next";
import { authenticationAction } from "_actions";
import { UserService } from "_services";
import { Helmet } from "react-helmet";
import toast from "react-hot-toast";
export const LoginLayout = (props) => {
  const model = Schema.Model({
    username: Schema.Types.StringType().isRequired(i18n.t("MSG_NULL_USERNAME")),
    password: Schema.Types.StringType().isRequired(i18n.t("MSG_NULL_PASSWORD")),
  });
  const formRef = React.useRef();
  const usernameRef = React.useRef();
  const passwordRef = React.useRef();
  const [formError, setFormError] = React.useState({});
  const [formValue, setFormValue] = React.useState({
    username: localStorage.getItem("rememberedUsername") || "",
    password: localStorage.getItem("rememberedPassword") || "",
  });
  const [loading, setLoading] = React.useState(false);
  const [rememberMe, setRememberMe] = React.useState(false);

  const checkToken = async () => {
    const { LoginSuccess, LoginFailure } = props;
    await UserService.USER_DETAIL()
      .then((res) => {
        if (res.RelUserType.TypeID == 5) {
          toast.success(
            `${i18n.t("MESSAGE_LOGIN_SUCCUESS")} ${res.RelUser.UserName}`
          );

          // Form değerlerini hatırla (sadece rememberMe true ise)
          if (rememberMe) {
            localStorage.setItem("rememberedUsername", formValue.username);
            localStorage.setItem("rememberedPassword", formValue.password);
          } else {
            localStorage.removeItem("rememberedUsername");
            localStorage.removeItem("rememberedPassword");
            //localStorage.clear()
          }

          LoginSuccess(res);
          setLoading(false);
        } else {
          localStorage.removeItem("access_token");
          localStorage.removeItem("expires_in");
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("user");
          localStorage.clear()
          toast.error(i18n.t("NO_PERMISSION_WITHOUT_GAMER"));
        }
      })
      .catch((err) => {
        debugger;
        LoginFailure();
      });
  };

  const restoreBodyScroll = () => {
    // Body scroll'u geri yükle
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.height = '';
    document.body.style.overflow = '';
  };
  const handleResize = () => {
    // Viewport değiştiğinde (keyboard açılıp kapanması)
    // Sadece gerçekten keyboard olayı ise scroll'u sıfırla
    setTimeout(() => {
      // Sadece body scroll'u varsa sıfırla (keyboard olayı)
      if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
    }, 100);
  };

  const handleSubmit = async () => {
    setLoading(true);

    setTimeout(() => {
      restoreBodyScroll();
      handleResize();
    }, 300);

    if (!formRef.current.check()) {
      console.error("Form Error");
      setLoading(false);
      return;
    } else {
      await OAuth2Service.LOGIN(formValue.username, formValue.password, false)
        .then((res) => {
          // Form değerlerini hatırla (sadece rememberMe true ise)
          if (rememberMe) {
            localStorage.setItem("rememberedUsername", formValue.username);
            localStorage.setItem("rememberedPassword", formValue.password);
          } else {
            localStorage.removeItem("rememberedUsername");
            localStorage.removeItem("rememberedPassword");
          }

          try {
            localStorage.removeItem('current_provider_/casino');
            localStorage.removeItem('scroll_position_/casino');
          }
          catch (error) {
            debugger;
          }

          checkToken();

        })
        .catch((err) => {
          debugger;

          if (err && err?.response?.status == 400) {
            toast.error(i18n.t("MESSAGE_LOGIN_FAILD"));
          } else if (err && err.response) {
            toast.error(err?.response?.data?.failText[0]);
          } else {
            toast.error(i18n.t("ERROR_RESPONSE_ERROR_UNDEFINED"));
          }
          setLoading(false);
        });
    }
  };

  const _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <Translation>
      {(t) => (
        <>
          <Helmet>
            <title >{t("TITLE_WELCOME_BACK")}</title>
          </Helmet>
          <div className="p-2 sm:p-0 my-auto flex flex-col justify-center items-center pt-6 sm:pt-0 bg-secondary-500 bgpattern">
            <span
              //style={{ fontSize: "xx-large" }}
              className=" mb-8 hellotext"
            >
              {t("TITLE_WELCOME_BACK")}
            </span>
            <div className="  sm:m-0 sm:mb-2 w-full sm:max-w-md mt-2 px-6 py-4 glass bg-gradient-to-r from-secondary-700 via-secondary-700 to-light-secondary-800 drop-shadow-2xl  overflow-hidden  rounded-lg">
              <Form
                disabled={loading}
                ref={formRef}
                fluid
                model={model}
                onChange={setFormValue}
                onCheck={setFormError}
                formValue={formValue}
              >
                <Form.Group>
                  <Form.ControlLabel className="label-text">
                    {t("TXT_USERNAME")}
                  </Form.ControlLabel>
                  <Form.Control
                    ref={usernameRef}
                    onKeyDown={_handleKeyDown}
                    id="username"
                    className="input input-bordered w-full max-w outline-secondary-500 bg-secondary-700 auth-input"
                    name="username"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.ControlLabel className="label-text">
                    {t("TXT_PASSWORD")}
                  </Form.ControlLabel>
                  <Form.Control
                    ref={passwordRef}
                    onKeyDown={_handleKeyDown}
                    id="password"
                    className="input input-bordered w-full max-w outline-secondary-500 bg-secondary-700 auth-input"
                    name="password"
                    type="password"
                    autoComplete="off"
                  />
                </Form.Group>
                <Form.Group>
                  <div className="flex items-center justify-center">
                    <label className="flex items-center cursor-pointer group">
                      <div className="relative">
                        <input
                          type="checkbox"
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                          className="sr-only"
                        />
                        <div className={`w-5 h-5 rounded border-2 transition-all duration-200 ${rememberMe
                            ? 'bg-primary-500 border-primary-500 shadow-lg shadow-primary-500/30'
                            : 'border-gray-300 hover:border-primary-400 group-hover:border-primary-400'
                          }`}>
                          {rememberMe && (
                            <svg
                              className="w-3 h-3 text-white absolute top-0.5 left-0.5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                          )}
                        </div>
                      </div>
                      <span className="text-white text-sm ml-3 font-medium select-none group-hover:text-primary-200 transition-colors duration-200">
                        {t("REMEMBER_ME")}
                      </span>
                    </label>
                  </div>
                </Form.Group>
                <Form.Group>
                  <ButtonToolbar>

                    <Button
                      loading={loading}
                      className="btn btn-primary btn-md btn-block text-white"
                      onClick={handleSubmit}
                    >
                      {t("BUTTON_SIGNIN")}
                    </Button>
                    {/*+
                  
                     <Button appearance="link">Forgot password?</Button>
                    */}
                  </ButtonToolbar>
                </Form.Group>
              </Form>
              <div className="w-full flex justify-center">
                <span className="mt-2 font-light text-primary-50/50">
                  {t("VERSION")}
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication } = state;
  const { user, loggedIn } = authentication;

  return {
    user,
    loggedIn,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateUser: (user) => dispatch(authenticationAction.UpdateUser(user)),
    LoginSuccess: (user) => dispatch(authenticationAction.LoginSuccess(user)),
    LoginFailure: () => dispatch(authenticationAction.LoginFailure()),
    logout: () => dispatch(authenticationAction.logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginLayout);
